import { OnChanges, SimpleChanges, OnDestroy, Injector } from '@angular/core';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { RadMeter } from '../../../components/catalogs/meters-catalog/rad-meters';
import { Observable, Subscription } from 'rxjs';
import { ClRadMetersAddComponent } from './cl-rad-meters-add/cl-rad-meters-add.component';
import moment from 'moment';
import { ClBaseComponent } from '../cl-base/cl-base.component';
import { FormStatusEnum } from 'src/app/common/enumerations/enumerations';
import { Checklist } from 'src/app/components/checklists/checklists';
import { YesNoDialogComponent } from '../../yes-no-dialog/yes-no-dialog.component';
import { RadMetersService } from 'src/app/components/catalogs/meters-catalog/services/rad-meters.service';
import { RadMetersRefresh, RadMetersUpdate } from 'src/app/components/catalogs/meters-catalog/store/rad-meters/rad-meters.action';

@Component({
  selector: 'cl-rad-meters',
  templateUrl: './cl-rad-meters.component.html',
  styleUrls: ['./cl-rad-meters.component.scss']
})
export class ClRadMetersComponent extends ClBaseComponent implements OnInit, OnChanges, OnDestroy {

  radMetersList!: RadMeter[];
  radMeters!: RadMeter[];
  radMeters$!: Observable<RadMeter[]>;
  radMetersSubs!: Subscription;

  selectedRowIndex!: number;

  dueDateChanging?: number | null;
  sourceReadingChanging?: number | null;
  backgroundReadingChanging?: number | null;

  currentChecklist?: Checklist;

  public dataSource: MatTableDataSource<RadMeter> = new MatTableDataSource<RadMeter>();
  public displayedColumns!: string[];

  space = '_________________';

  constructor(
    protected override injector: Injector,
    private service: RadMetersService
  ) {
    super(injector);
    this.store.dispatch(new RadMetersRefresh());
  }

  override ngOnDestroy(): void {
    this.radMetersSubs?.unsubscribe();
    super.ngOnDestroy();
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    this.currentChecklist = this.checklist as Checklist;

    this.loadRadMeters();
    this.displayedColumns = this.canModify() ? ['serialNumber', 'calibrationDate', 'model', 'type', 'unit', 'sourceReading', 'backgroundReading', 'actions'] : ['serialNumber', 'calibrationDate', 'model', 'type', 'unit', 'sourceReading', 'backgroundReading'];
    this.loadData();
  }

  async ngOnInit(): Promise<void> {

  }

  loadRadMeters() {
    this.radMeters$ = this.store.select(state => state.RadMeters.data);
    this.radMetersSubs = this.radMeters$.subscribe(data => {
      this.radMeters = data;
      this.loadData();
    });
  }

  loadData() {
    if (this.configuration) {
      this.radMetersList = this.utils.JSONparse(this.configuration).data;
      let id = 1;
      this.radMetersList.map(m => {
        m.id = id;
        m.backgroundReadingChangedBy = this.getUsers()?.find(u => u.id == m.backgroundReadingChangedByID);
        m.sourceReadingChangedBy = this.getUsers()?.find(u => u.id == m.sourceReadingChangedByID);
        m.calibrationDueDateChangedBy = this.getUsers()?.find(u => u.id == m.calibrationDueDateChangedByID);
        const radMeter = this.radMeters?.find(x => x.serialNumber == m.serialNumber);
        if (radMeter) {
          m.radMeterModel = radMeter.radMeterModel;
          m.radMeterModelID = radMeter.radMeterModelID;
          m.radMeterType = radMeter.radMeterType;
          m.radMeterTypeID = radMeter.radMeterTypeID;
          m.radMeterUnit = radMeter.radMeterUnit;
          m.radMeterUnitID = radMeter.radMeterUnitID;
          if (this.checklist?.checklistStatus?.formStatusID == FormStatusEnum.Active || this.checklist?.checklistStatus?.formStatusID == FormStatusEnum.Draft) {
            if (m.calibrationDueDate != radMeter.calibrationDueDate) {
              m.calibrationDueDate = radMeter.calibrationDueDate;
              m.calibrationDueDateChangedBy = radMeter.calibrationDueDateChangedBy;
              m.calibrationDueDateChangedByID = radMeter.calibrationDueDateChangedByID;
              m.calibrationDueDateChangedOn = radMeter.calibrationDueDateChangedOn;
              this.saveData();
            }
          }
        }

        id++;
      });
      this.dataSource.data = this.radMetersList;
    }
    else {
      this.radMetersList = [];
    }
  }

  change() {
    this.changed.emit(this.configuration);
  }

  accept() {
    this.save.emit(this.configuration);
  }

  addMeter() {
    const dialog = this.dialog.open(ClRadMetersAddComponent,
      {
        data: this.radMetersList,
        disableClose: true,
        width: '600px',
        autoFocus: false
      });
    dialog.afterClosed().subscribe(data => {
      if (data) {
        const lastID = this.radMetersList.length ? Math.max(...this.radMetersList.map(x => x.id) as number[]) : 0;
        data.id = lastID + 1;
        this.radMetersList.push(data);
        this.saveData();
      }
    });
  }

  deleteRowMeter(rowMeter: RadMeter) {
    const confirm = this.dialog.open(YesNoDialogComponent, {
      width: '400px',
      data: {
        message: this.getMessage('RadMeterDeleteConfirm').description,
        icon: 'stop'
      }
    });

    confirm.afterClosed().subscribe(data => {
      if (data) {
        const index = this.radMetersList.findIndex(x => x.id == rowMeter.id);
        this.radMetersList.splice(index, 1);
        this.saveData();
      }
    });
  }

  canModify() {
    return this.hasRoles(this.roleIds) && !this.disabled;
  }


  textSourceChanged(r: RadMeter) {
    const radMeter = this.radMetersList.find(x => x.id == r.id);
    if (radMeter) {
      if (!r.sourceReading) {
        radMeter.sourceReading = null;
        radMeter.sourceReadingChangedBy = null;
        radMeter.sourceReadingChangedByID = null;
        radMeter.sourceReadingChangedOn = null;
      }
      else {
        radMeter.sourceReadingChangedBy = this.getCurrentUser(true);
        radMeter.sourceReadingChangedByID = this.getCurrentUser()?.id;
        radMeter.sourceReadingChangedOn = new Date();
      }
      this.sourceReadingChanging = null;
      this.saveData();
    }
  }

  textBackgroundChanged(r: RadMeter) {
    const radMeter = this.radMetersList.find(x => x.id == r.id);
    if (radMeter) {
      if (!r.backgroundReading) {
        radMeter.backgroundReading = null;
        radMeter.backgroundReadingChangedBy = null;
        radMeter.backgroundReadingChangedByID = null;
        radMeter.backgroundReadingChangedOn = null;
      }
      else {
        radMeter.backgroundReadingChangedBy = this.getCurrentUser(true);
        radMeter.backgroundReadingChangedByID = this.getCurrentUser()?.id;
        radMeter.backgroundReadingChangedOn = new Date();
      }
      this.backgroundReadingChanging = null;
      this.saveData();
    }
  }

  changeCalDueDate(e: RadMeter) {
    const confirm = this.dialog.open(YesNoDialogComponent, {
      data: {
        message: this.getMessage('RadMeterChangeCalDate').description,
        icon: 'stop'
      }
    });

    confirm.afterClosed().subscribe(data => {
      if (data) {
        this.dueDateChanging = e.id;
      }
    });
  }

  changeSourceReading(e: RadMeter) {
    this.sourceReadingChanging = e.id;
  }

  changeBackgroundReading(e: RadMeter) {
    this.backgroundReadingChanging = e.id;
  }

  calDueDateChanged(r: RadMeter) {
    const date = moment(r.calibrationDueDate);
    if (date.isValid()) {
      const radMeter = this.radMetersList.find(x => x.id == r.id);
      if (radMeter) {
        radMeter.calibrationDueDate = r.calibrationDueDate;
        radMeter.calibrationDueDateChangedBy = this.getCurrentUser(true);
        radMeter.calibrationDueDateChangedByID = this.getCurrentUser()?.id;
        radMeter.calibrationDueDateChangedOn = new Date();
        this.dueDateChanging = null;
        this.saveData();
        this.saveCalDueDate(radMeter);
      }
    }
  }

  saveData() {
    const radMetersList: any[] = [];
    this.radMetersList.map(r => {
      radMetersList.push(this.utils.Serialize(r));
    });
    this.configuration = this.utils.JSONstringify({ data: radMetersList });
    this.dataSource.data = this.radMetersList;
    this.changed.emit(this.configuration);
  }

  saveCalDueDate(radMeter: RadMeter) {
    this.service.updateRadMeterCatalog(radMeter).toPromise();
  }

  isDateExpired(date: Date) {
    if (this.currentChecklist?.checklistStatus?.formStatusID !== FormStatusEnum.Closed && this.currentChecklist?.checklistStatus?.formStatusID !== FormStatusEnum.Canceled) {
      const mdate = moment(date);
      return mdate.isBefore(new Date());
    }
    return false;
  }
}
